"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dimensions = {
    avatar: {
        tiny: 20,
        compact: 24,
        small: 28,
        medium: 40,
        large: 64,
    },
};
exports.default = dimensions;
